import { SWRConfiguration } from 'swr';

import { CompanyFormType } from '~/data/documents/types';
import { UseArraySWROutput, useArraySWR } from '~/hooks/useSWR';
import { fetchFromOldApi } from '~/services/Http';

export const getCompanyForms = (): Promise<CompanyFormType[]> =>
  fetchFromOldApi('/json/form/company').then((r) => r.json());

export const useGetCompanyForms = (
  swrConfig?: SWRConfiguration<CompanyFormType[]>,
  isDisabled?: boolean,
): UseArraySWROutput<CompanyFormType> => {
  return useArraySWR(
    !isDisabled ? ['companyForms'] : null,
    () => getCompanyForms(),
    swrConfig,
  );
};
